import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import HighlightedTitle from "./HighlightedTitle";

const useStyles = makeStyles(theme => ({
  titleContainer: {
    background: "none",
    padding: 0
  },
  card: {
    padding: theme.spacing(2.5, 6, 2, 5),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2.5, 3, 2, 3)
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2.5)
    },
    minHeight: 136 // Fix for IE
  },
  list: {
    "& > li:first-of-type": {
      borderTop: "none"
    }
  },
  cardContent: {
    flex: "unset", // fix for IE
    padding: theme.spacing(0, 3, 0.25, 0),
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0
    },
    "&:last-child": {
      paddingBottom: theme.spacing(1)
    }
  }
}));

function CourseModule(props) {
  const classes = useStyles();

  return (
    <div>
      <Card className={classes.card}>
        <CardHeader
          title={
            <Typography variant="h6" color="textPrimary">
              <HighlightedTitle
                title={props.title}
                searchInput={props.searchInput}
              />
            </Typography>
          }
          classes={{ root: classes.titleContainer }}
        />
        <CardContent classes={{ root: classes.cardContent }}>
          <List
            component="nav"
            aria-label="Course Activity List"
            classes={{ root: classes.list }}
          >
            {props.activityList}
          </List>
        </CardContent>
      </Card>
    </div>
  );
}

export default CourseModule;

CourseModule.propTypes = {
  title: PropTypes.string,
  activityList: PropTypes.arrayOf(PropTypes.node),
  searchInput: PropTypes.string
};
